import { render, staticRenderFns } from "./ManagerSelector.vue?vue&type=template&id=74cc2957&scoped=true&"
import script from "./ManagerSelector.vue?vue&type=script&lang=js&"
export * from "./ManagerSelector.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSelector.vue?vue&type=style&index=0&id=74cc2957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc2957",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
